<template>
  <div class="app-home">
    <v-header v-bind:user="user" />
    <users-list v-bind:user="user" />
  </div>
</template>

<script>
import VHeader from "@/components/header.vue";
import UsersList from "@/components/admin/users/UsersTable.vue";
import User from "@/models/User.js";
// @ is an alias to /src
export default {
  name: "app-home",
  data() {
    return {
      user: new User(this.$session.get("user")),
    };
  },

  mounted() {
    this.checkUser(this.user);
  },

  methods: {
    checkUser(user) {
      if (this.user.company_id == 9) {
        this.$session.destroy();
        this.$router.push("/login").catch(() => {});
      }
      if (![0, 1].includes(user["type"])) {
        this.$session.destroy();
        this.$router.push("/login").catch(() => {});
      }
    },
  },

  components: {
    VHeader,
    UsersList,
  },
};
</script>
